module.exports = __webpack_public_path__ + "img/paypal-system.8e0aa172.svg";